<template>
</template>

<script>
export default {
  name: "SingleBrand"
}
</script>

<style scoped>

</style>